import { TFunction } from 'i18next';
import type { VariableOption } from '../../documents/form/inputs/mentionSuggestion';
import { Variable } from '../../../services/api/departmentVariablesService';
import { variableLabel } from '../../department-variables/utils/settingsView';

export function buildVariableOptions(
    variables: Variable[],
    t: TFunction
): VariableOption[] {
    return variables
        .filter((variable) =>
            variable.type === 'fixed'
                ? !!variable.fixedValue
                : !!variable.refId || !!variable.fixedValue
        )
        .map((variable) => ({
            name: variable.name,
            label: variableLabel(variable, t),
        }));
}
